module.exports = __webpack_public_path__ + "img/200px-HK_Exchange_Square.bcde2b7b.jpg";